
import { Button } from "@/components/ui/button";
import AnimatedSection from "./AnimatedSection";

const Hero = () => {
  const scrollToNewsletter = () => {
    const newsletterSection = document.querySelector('section.section-padding');
    if (newsletterSection) {
      window.scrollTo({
        top: newsletterSection.getBoundingClientRect().top + window.scrollY - 100,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden">
      <div className="container-narrow grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">
        <AnimatedSection 
          animation="fade-in-left"
          className="flex flex-col items-center lg:items-start text-center lg:text-left"
        >
          <div className="inline-block px-3 py-1 mb-6 rounded-full bg-primary/10 text-primary text-xs font-medium tracking-wider">
            BETA LAUNCHING SOON
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold tracking-tight mb-6 max-w-2xl">
            No-Code Visual Bayesian Workflows
          </h1>
          <p className="text-lg text-muted-foreground mb-8 max-w-xl">
            Transform complex data into clear insights with intuitive node-based Bayesian workflows. Analyse data faster and make better decisions without writing a single line of code.
          </p>
          <div>
            <Button 
              size="lg" 
              className="rounded-full px-8"
              onClick={scrollToNewsletter}
            >
              Join Beta
            </Button>
          </div>
        </AnimatedSection>

        <AnimatedSection 
          animation="fade-in-right"
          delay={300}
          className="flex justify-center lg:justify-end"
        >
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-accent/20 rounded-3xl blur-3xl opacity-30 animate-pulse-subtle"></div>
            <img 
              src="/hero-image.svg" 
              alt="Visual data workflow" 
              className="relative z-10 w-full max-w-lg lg:max-w-xl animate-float"
            />
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default Hero;
